import * as types from '../mutation-types'

const state = {
  pinOnMapMode: false,
  pinIcon: 'pickup',
  pinPayload: {
    lat: null,
    lng: null,
    label: ''
  }
}

const getters = {}

const actions = {
  setPinOnMapMode({ commit }, value) {
    commit(types.SET_PIN_ON_MAP_MODE, value)
  },
  setPinOnMapIcon({ commit }, icon) {
    commit(types.SET_PIN_ON_MAP_ICON, icon)
  },
  updatePinPayload({ commit }, payload) {
    if (payload.lat && payload.lng) {
      commit(types.UPDATE_PIN_PAYLOAD, payload)
    }
  },
  resetPinPayload({ commit }) {
    commit(types.UPDATE_PIN_PAYLOAD, {
      lat: null,
      lng: null,
      label: ''
    })
  }
}

const mutations = {
  [types.SET_PIN_ON_MAP_MODE](state, value) {
    state.pinOnMapMode = value
  },
  [types.UPDATE_PIN_PAYLOAD](state, payload) {
    state.pinPayload = payload
  },
  [types.SET_PIN_ON_MAP_ICON](state, icon) {
    state.pinIcon = icon
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
